module.exports = __webpack_public_path__ + "static/media/address.d68b0c80.svg";